import React from "react";
import { inject, observer } from "mobx-react";
import { ProposalStore } from "../../../stores/proposalStore";
import { Animal } from "./animal/animal";
import { CalculateStore } from "../../../stores/calculateStore";

interface CatAndDogProps {
  proposalStore?: ProposalStore;
  calculateStore?: CalculateStore;
}

@inject("proposalStore", "calculateStore")
@observer
export default class CatAndDog extends React.Component<CatAndDogProps> {

  public render() {
    return (
      <>
        {this.isCatAndDogInsured() && (
          <div className="cat-and-dog">
            {this.renderCatsAndDogs()}
          </div>
        )}
      </>
    );
  }

  private isCatAndDogInsured(): boolean {
    return this.props.calculateStore!.additionalInsurances.catAndDog.checked;
  }

  private numberOfAnimals() {
    return this.props.calculateStore!.additionalInsurances.catAndDog.catAndDogCount();
  }

  private renderCatsAndDogs() {
    return [...Array(this.numberOfAnimals())].map((_, index) => {
      const headerText = this.numberOfAnimals() === 1 ? `Dane psa lub kota` : `Dane psa lub kota (${index + 1})`;
      return <Animal
        key={`animal-${index}`}
        animal={this.props.proposalStore!.catAndDog.animals[index]}
        headerText={headerText} />;
    });
  }
}
